import CryptoJS from "crypto-js";
import { getClientTraceHeaders } from "./clientTraceHeaders";

const AUTH_TOKEN_COOKIE = "authToken";
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 год в секундах

/**
 * Хеширует email для использования в качестве authToken
 * Использует SHA-256 для детерминированного хеширования
 */
export function hashEmail(email: string): string {
  if (!email) {
    throw new Error("Email is required for hashing");
  }
  return CryptoJS.SHA256(email.toLowerCase().trim()).toString();
}

/**
 * Получает authToken из cookies
 */
export function getAuthToken(): string | null {
  const match = document.cookie.match(new RegExp("(^| )" + AUTH_TOKEN_COOKIE + "=([^;]+)"));
  return match ? match[2] : null;
}

/**
 * Сохраняет authToken в cookies
 */
export function setAuthToken(token: string): void {
  document.cookie = `${AUTH_TOKEN_COOKIE}=${token}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
}

/**
 * Удаляет authToken из cookies
 */
export function removeAuthToken(): void {
  document.cookie = `${AUTH_TOKEN_COOKIE}=; path=/; max-age=0`;
}

/**
 * Проверяет, является ли токен старым bcrypt форматом
 */
function isOldBcryptToken(token: string): boolean {
  return token.startsWith("$2b$") || token.startsWith("$2a$") || token.startsWith("$2y$");
}

/**
 * Получает заголовки для API запросов
 * Токен передается через cookies (автоматически с credentials: 'include')
 * Authorization заголовок добавляется для совместимости с бэкендом
 */
export function getAuthHeaders(additionalHeaders: Record<string, string> = {}): Record<string, string> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json;charset=utf-8",
    ...getClientTraceHeaders(),
    ...additionalHeaders,
  };

  let authToken = getAuthToken();
  
  if (authToken && isOldBcryptToken(authToken)) {
    removeAuthToken();
    authToken = null;
  }
  
  if (authToken) {
    headers["Authorization"] = `Bearer ${authToken}`;
  }

  return headers;
}
